//
//  GhaCsvIntradayButtonList.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ghaIntradayItems } from "../constants/ghaCsv";

type GhaCsvIntradayButtonListProps = {
  startDate: string;
  endDate: string;
  disabled: boolean;
  onRequest: (
    startDate: string,
    endDate: string,
    intradayItemId: string
  ) => void;
};

export const GhaCsvIntradayButtonList: React.FC<
  GhaCsvIntradayButtonListProps
> = ({ startDate, endDate, disabled, onRequest }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1.5}
      alignItems="center"
      width="100%"
    >
      {ghaIntradayItems.map((item) => {
        const label = item.description
          ? `${item.label}(${item.description})データをリクエスト`
          : `${item.label}データをリクエスト`;
        return (
          <Button
            key={item.type}
            variant="contained"
            color="primary"
            disabled={disabled}
            onClick={() => onRequest(startDate, endDate, item.type)}
            sx={{ width: 500, minWidth: 0, textTransform: "none" }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
};
